/**
 * HACK: hack specific to the account settings: in order to have the `Update` button on
 * account settings fire multiple requests to three different endpoints at once,
 * we keep reference to the different states under separate namespaces
 * (formState.accountDetails, formState.notificationSettings, formState.breedListMembers).
 * Then, since validate.js returns a shallow error object,
 * we need to modify the keys to omit those namespaces so the error keys match the field names.
 * For example: `formErrors['accountDetails.password']: 'Passwords must be at least 6 characters.` needs to be
 * transformed to `formErrors['password']: 'Passwords must be at least 6 characters.'`
 */

export function flattenFormErrors(formErrors, prefixToOmit) {
  return Object.entries(formErrors).reduce((carry, [errorKey, errorValue]) => {
    const splitKey = errorKey.split('.');

    if (splitKey[0] === prefixToOmit) {
      return {
        ...carry,
        [splitKey.slice(1).join('.')]: errorValue
      };
    }
    return {
      ...carry,
      [errorKey]: errorValue
    };
  }, {});
}
